"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _remarkStripMarkdown = _interopRequireDefault(require("../Utils/remarkStripMarkdown"));

var _ScreenReaderText = _interopRequireDefault(require("../ScreenReaderText"));

var _useRenderMarkdownAsHTML = _interopRequireDefault(require("../hooks/useRenderMarkdownAsHTML"));

var _useStyleSet3 = _interopRequireDefault(require("../hooks/useStyleSet"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var TextContent = function TextContent(_ref) {
  var contentType = _ref.contentType,
      text = _ref.text;
  var renderMarkdownAsHTML = (0, _useRenderMarkdownAsHTML.default)();

  var _useStyleSet = (0, _useStyleSet3.default)(),
      _useStyleSet2 = _slicedToArray(_useStyleSet, 1),
      textContentStyleSet = _useStyleSet2[0].textContent;

  var strippedText = (0, _remarkStripMarkdown.default)(text).contents;
  return contentType === 'text/markdown' && renderMarkdownAsHTML ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_ScreenReaderText.default, {
    text: strippedText
  }), _react.default.createElement("div", {
    "aria-hidden": true,
    className: (0, _classnames.default)('markdown', textContentStyleSet + ''),
    dangerouslySetInnerHTML: {
      __html: renderMarkdownAsHTML(text || '')
    }
  })) : (text || '').split('\n').map(function (line, index) {
    return _react.default.createElement(_react.default.Fragment, {
      key: index
    }, _react.default.createElement(_ScreenReaderText.default, {
      text: (0, _remarkStripMarkdown.default)(line.trim()).contents
    }), _react.default.createElement("p", {
      "aria-hidden": true,
      className: (0, _classnames.default)('plain', textContentStyleSet + '')
    }, line.trim()));
  });
};

TextContent.defaultProps = {
  contentType: 'text/markdown'
};
TextContent.propTypes = {
  contentType: _propTypes.default.string,
  text: _propTypes.default.string.isRequired
};
var _default = TextContent;
exports.default = _default;